<template>
  <q-knob
    :model-value="credit.consumed_resources"
    :min="0"
    :max="credit.total_resources"
    readonly
    show-value
    size="42px"
    :color="
      percentage < 80 ? 'primary' : percentage < 90 ? 'warning' : 'negative'
    "
    track-color="grey-3"
    class="text-base-color"
  >
    {{ percentage }}%
    <q-tooltip>
      <p class="q-mb-xs">{{ credit.name }}:</p>
      <p class="q-mb-xs">
        {{ $t('receiver.billing.subscription.credit.consumed') }}:
        <span
          class="text-weight-medium"
          :class="
            percentage < 80
              ? 'text-primary'
              : percentage < 90
                ? 'text-warning'
                : 'text-negative'
          "
         
        >
          {{ credit.consumed_resources }}
        </span>
      </p>
      <p class="q-mb-xs">
        {{ $t('receiver.billing.subscription.credit.total') }}:
        <span class="text-weight-medium">
          {{ credit.total_resources }}
        </span>
      </p>
      <p v-if="renewalDate">
        {{
          $t('receiver.billing.subscription.credit.renew', {
            date: formatDate(renewalDate, 'DD MMM YYYY'),
          })
        }}
      </p>
    </q-tooltip>
  </q-knob>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { date } from 'quasar'

import type { BillingCreditType } from 'types/common/account/user'

// PROPS
const { credit } = defineProps<{
  credit: BillingCreditType
  renewalDate: string | null
}>()

const { formatDate } = date

const percentage = computed(() =>
  Math.round((credit.consumed_resources / credit.total_resources) * 100)
)
</script>
